import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import "./mainfeature.css";

const FeatureIndex = () => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const handleHover = (index) => {
    setHoveredIndex(index);
  };

  const handleLeave = () => {
    setHoveredIndex(null);
  };

  const items = ["RaaS", "Quiz", "LMS", "CISO", "VLAB", "Threat Assessment"];
  return (
    <div>
      <Grid container>
        <Grid item md={12}>
          {/* <div className="component csstransforms">
            <button className="cn-button" id="cn-button">
              IVP
            </button>
            <div className="cn-wrapper opened-nav" id="cn-wrapper">
              <ul>
                <li>
                  <a href="#">
                    <span>RaaS</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span>Quiz</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span>LMS</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span>CISO</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span>VLAB</span>
                  </a>
                </li>
                <li>
                  <a href="#">
                    <span>Threat Assessment</span>
                  </a>
                </li>
              </ul>
            </div>
          </div> */}
          <div className="component csstransforms">
            <button className="cn-button" id="cn-button">
              IVP
            </button>
            <div className="cn-wrapper opened-nav" id="cn-wrapper">
              <ul>
                {items.map((item, index) => (
                  <li
                    key={index}
                    className={index === hoveredIndex ? "bounce-in" : ""}
                    onMouseEnter={() => handleHover(index)}
                    onMouseLeave={handleLeave}
                  >
                    <a href="#">
                      <span>{item}</span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default FeatureIndex;
